// src/components/newBatchTempForm.js
// src/components/newBatchTempForm.js
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";

import MachinesList3 from "./machineList3";
import ProdListBut from "./prodListButton";
import ModelListBut from "./modelListButton";
import ShiftList2 from "./shiftList2";
import OperatorList2 from "./operatorList2";

import { getBatchTemp, createBatchTemp, updateBatchTemp } from "../api";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from "date-fns/locale";
import { format } from "date-fns";

// ✅ Helper: parsea "YYYY-MM-DD" a Date local (sin desfase por zona horaria)
const parseYMDToLocalDate = (s) => {
  if (!s) return null;
  const [y, m, d] = s.slice(0, 10).split("-").map(Number);
  const dt = new Date(y, m - 1, d); // medianoche local
  return Number.isNaN(dt.getTime()) ? null : dt;
};

const formatTime = (date) => {
  if (!date) return null;
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}:00`; // formato TIME para MySQL
};

// Construye un Date con una hora HH:mm(:ss) sobre una fecha base "YYYY-MM-DD"
const buildDateWithTime = (yyyy_mm_dd, hh_mm_ss) => {
  if (!yyyy_mm_dd || !hh_mm_ss) return null;
  try {
    const [y, m, d] = yyyy_mm_dd.split("-").map(Number);
    const [hh, mm] = hh_mm_ss.split(":").map(Number); // segundos opcionales
    const dt = new Date(y, m - 1, d, hh, mm || 0, 0, 0);
    return Number.isNaN(dt.getTime()) ? null : dt;
  } catch {
    return null;
  }
};




const NewBatchTempForm = () => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const { id: routeId } = useParams();

  const company = JSON.parse(localStorage.getItem("company"));
  const user = JSON.parse(localStorage.getItem("user"));
  const id_c = company?.id_c;
  const id_user = user?.id_u;

  const isEdit = Boolean(routeId);

  // === mismos estados y look&feel que NewBatchForm ===
  const [loteCod, setBatch] = useState("");
  const [idShift, setIdShift] = useState("");
  const [idOperator, setIdOperator] = useState("");
  const [idProd, setIdProd] = useState("");
  const [model, setModel] = useState("");
  const [codMaq, setCodMaq] = useState("");

  const [fechaIni, setFechaIni] = useState(null); // Date
  const [timeIni, setTimeIni] = useState(null);   // Date
  const [timeFin, setTimeFin] = useState(null);   // Date

  const [undOK, setUndOK] = useState("");
  const [undNC, setUndNC] = useState("");

  useEffect(() => {
    const load = async () => {
      if (!isEdit) return;
      const data = await getBatchTemp(id_c, routeId); // { batch: {...} }
      const b = data?.batch || {};

      setBatch(b.id_batch || "");
      setIdShift(b.id_shift || "");
      setIdOperator(b.id_operator || "");
      setIdProd(b.id_prod || "");
      setModel(b.model || "");
      setCodMaq(b.cod_maq || "");

      // convertir strings a DatePickers:

      //const d = b.date_begin ? b.date_begin.slice(0,10) : null; // yyyy-MM-dd
      const d = b.date_begin ? b.date_begin.slice(0,10) : null;
      //setFechaIni(d ? new Date(d) : null);
      setFechaIni(parseYMDToLocalDate(d));
      setTimeIni(buildDateWithTime(d, b.time_begin?.slice(0,5)));
      setTimeFin(buildDateWithTime(d, b.time_end?.slice(0,5)));

      setUndOK(b.cant_pt_ok ?? "");
      setUndNC(b.cant_pt_nc ?? "");
    };
    load();
  }, [id_c, isEdit, routeId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        id_batch: loteCod,
        id_c,
        id_user,
        cod_maq: codMaq,
        id_prod: idProd,
        model,

        id_shift: idShift,
        id_operator: idOperator,

        date_begin: fechaIni ? format(fechaIni, "yyyy-MM-dd") : null,
        time_begin: formatTime(timeIni),

        // opcionales (pueden ir null si guardas incompleto)
        time_end: timeFin ? formatTime(timeFin) : null,
        cant_pt_ok: undOK !== "" ? parseInt(undOK, 10) : null,
        cant_pt_nc: undNC !== "" ? parseInt(undNC, 10) : null
      };

      if (isEdit) {
        await updateBatchTemp(id_c, routeId, payload);
        alert("✅ Actualizado en temporal");
      } else {
        await createBatchTemp(id_c, payload);
        alert("✅ Creado en temporal");
      }
      navigate("/6.batches_temp"); // ajusta si usas /6.batches_temp
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Error al guardar");
    }
  };

  const handleGoBack = () => navigate(-1);

  return (
    <div className="box1">
      <div className="box9">
        <form onSubmit={handleSubmit}>
          <table className="form1">
            <tbody>
              <tr>
                <td><label htmlFor="lote_code">{t("batchList12")}</label></td>
                <td>
                  <input
                    className="input1"
                    type="text"
                    value={loteCod}
                    onChange={(e) => setBatch(e.target.value)}
                    id="lote_code"
                    name="lote_code"
                    required
                  />
                </td>
              </tr>

              {/* Turno */}
              <tr>
                <td><label>{t("shifts1") || "Turno (id_shift)"}</label></td>
                <td>
                  <ShiftList2
                    id_c={id_c}
                    value={idShift}
                    onSelect={(v) => setIdShift(v)}
                  />
                </td>
              </tr>

              {/* Operador */}
              <tr>
                <td><label>{t("operator1") || "Operador (id_operator)"}</label></td>
                <td>
                  <OperatorList2
                    id_c={id_c}
                    value={idOperator}
                    onSelect={(v) => setIdOperator(v)}
                  />
                </td>
              </tr>


{/* Producto */}
<tr>
  <td><label htmlFor="cod_producto">{t("batchList3")}</label></td>
  <td>
    {isEdit ? (
      // Read-only en edición
      <span className="input1" style={{ padding: "4px 8px", display: "inline-block" }}>
        {idProd || "-"}
      </span>
    ) : (
      // Selector en creación
      <ProdListBut
        id_c={id_c}
        value={idProd}
        onSelect={(v) => setIdProd(v)}
      />
    )}
  </td>
</tr>

{/* Modelo */}
<tr>
  <td><label htmlFor="cod_model">{t("batchList27")}</label></td>
  <td>
    {isEdit ? (
      <span className="input1" style={{ padding: "4px 8px", display: "inline-block" }}>
        {model ?? "-"}
      </span>
    ) : (
      <ModelListBut
        id_c={id_c}
        id_prod={idProd}
        value={model}
        onSelect={(v) => setModel(v)}
      />
    )}
  </td>
</tr>

{/* Máquina */}
<tr>
  <td><label htmlFor="cod_maquina">{t("batchList2")}</label></td>
  <td>
    {isEdit ? (
      <span className="input1" style={{ padding: "4px 8px", display: "inline-block" }}>
        {codMaq || "-"}
      </span>
    ) : (
      <MachinesList3
        id_c={id_c}
        id_prod={idProd}
        value={codMaq}
        onSelect={(v) => setCodMaq(v)}
      />
    )}
  </td>
</tr>


              {/* Fecha inicio */}
              <tr>
                <td><label htmlFor="fecha_ini">{t("batchList7")}</label></td>
                <td>
                  <DatePicker
                    selected={fechaIni}
                    onChange={(date) => setFechaIni(date)}
                    dateFormat="yyyy-MM-dd"
                    locale={es}
                    placeholderText="AAAA-MM-DD"
                    className="input1"
                    id="fecha_ini"
                    name="fecha_ini"
                    required
                  />
                </td>
              </tr>

              {/* Hora inicio */}
              <tr>
                <td><label htmlFor="time_ini">{t("batchList8")}</label></td>
                <td>
                  <DatePicker
                    selected={timeIni}
                    onChange={(date) => setTimeIni(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    placeholderText="Selecciona hora"
                    className="input1"
                    id="time_ini"
                    name="time_ini"
                    required
                  />
                </td>
              </tr>

              {/* Hora fin (opcional mientras está en temp) */}
              <tr>
                <td><label htmlFor="time_fin">{t("batchList10")}</label></td>
                <td>
                  <DatePicker
                    selected={timeFin}
                    onChange={(date) => setTimeFin(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    placeholderText="Selecciona hora"
                    className="input1"
                    id="time_fin"
                    name="time_fin"
                  />
                </td>
              </tr>

              {/* PT OK / PT NC (opcionales en temp) */}
              <tr>
                <td><label htmlFor="und_OK">{t("batchList5")}</label></td>
                <td>
                  <input
                    className="input1"
                    type="number"
                    value={undOK}
                    onChange={(e) => setUndOK(e.target.value)}
                    id="und_OK"
                    name="und_OK"
                    min="0"
                  />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="und_NC">{t("batchList6")}</label></td>
                <td>
                  <input
                    className="input1"
                    type="number"
                    value={undNC}
                    onChange={(e) => setUndNC(e.target.value)}
                    id="und_NC"
                    name="und_NC"
                    min="0"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <button type="submit" className="button7">
            {isEdit ? t("prodList12") || "Guardar" : t("prodList12") || "Crear"}
          </button>
          <button type="button" className="button7" onClick={handleGoBack}>
            {t("prodList13") || "Volver"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewBatchTempForm;
